"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginWithKeeper = exports.onKeeperNetworkChanged = exports.onKeeperLockedChanged = exports.onKeeperUserChanged = exports.keeperErrors = exports.keeperPromise = void 0;
var getPublicState = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, exports.keeperPromise
                .then(function (keeper) { return keeper === null || keeper === void 0 ? void 0 : keeper.resourceIsApproved().then(function (isApproved) { return isApproved ? keeper === null || keeper === void 0 ? void 0 : keeper.publicState() : undefined; }); })];
    });
}); };
exports.keeperPromise = new Promise(function (resolve) { return setTimeout(resolve, 300); })
    .then(function () {
    var _a;
    return typeof window !== 'undefined'
        ? (_a = window === null || window === void 0 ? void 0 : window.WavesKeeper) === null || _a === void 0 ? void 0 : _a.initialPromise.then(function () { return window === null || window === void 0 ? void 0 : window.WavesKeeper; })
        : undefined;
});
exports.keeperErrors = {
    noKeeper: 'noKeeper',
    rejectedByUser: 'rejectedByUser',
    wrongNetwork: 'wrongNetwork',
};
var onKeeperUserChanged = function (callback) { return __awaiter(void 0, void 0, void 0, function () {
    var keeper, oldUser_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, exports.keeperPromise];
            case 1:
                keeper = _c.sent();
                if (!keeper) return [3 /*break*/, 3];
                return [4 /*yield*/, getPublicState()];
            case 2:
                oldUser_1 = (_b = (_a = (_c.sent())) === null || _a === void 0 ? void 0 : _a.account) === null || _b === void 0 ? void 0 : _b.address;
                keeper.on("update", function (state) {
                    var _a, _b, _c;
                    if (oldUser_1 != ((_a = state.account) === null || _a === void 0 ? void 0 : _a.address)) {
                        callback({
                            oldUser: oldUser_1,
                            newUser: (_b = state.account) === null || _b === void 0 ? void 0 : _b.address,
                        });
                        oldUser_1 = (_c = state.account) === null || _c === void 0 ? void 0 : _c.address;
                    }
                });
                _c.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.onKeeperUserChanged = onKeeperUserChanged;
var onKeeperLockedChanged = function (callback) { return __awaiter(void 0, void 0, void 0, function () {
    var keeper, locked_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, exports.keeperPromise];
            case 1:
                keeper = _c.sent();
                if (!keeper) return [3 /*break*/, 3];
                return [4 /*yield*/, getPublicState()];
            case 2:
                locked_1 = (_b = (_a = (_c.sent())) === null || _a === void 0 ? void 0 : _a.locked) !== null && _b !== void 0 ? _b : undefined;
                keeper.on("update", function (state) {
                    if (locked_1 != state.locked) {
                        locked_1 = state.locked;
                        callback({ locked: locked_1 });
                    }
                });
                _c.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.onKeeperLockedChanged = onKeeperLockedChanged;
var onKeeperNetworkChanged = function (callback) { return __awaiter(void 0, void 0, void 0, function () {
    var keeper, network_1;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, exports.keeperPromise];
            case 1:
                keeper = _d.sent();
                if (!keeper) return [3 /*break*/, 3];
                return [4 /*yield*/, getPublicState()];
            case 2:
                network_1 = (_c = (_b = (_a = (_d.sent())) === null || _a === void 0 ? void 0 : _a.network) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : undefined;
                keeper.on("update", function (state) {
                    if (network_1 != state.network.code) {
                        network_1 = state.network.code;
                        callback({ network: network_1 });
                    }
                });
                _d.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.onKeeperNetworkChanged = onKeeperNetworkChanged;
var loginWithKeeper = function (_a) {
    var chainId = _a.chainId;
    return __awaiter(void 0, void 0, void 0, function () {
        var keeper, acc;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, exports.keeperPromise];
                case 1:
                    keeper = _b.sent();
                    if (!keeper)
                        throw exports.keeperErrors.noKeeper;
                    return [4 /*yield*/, (keeper === null || keeper === void 0 ? void 0 : keeper.publicState().then(function (x) {
                            if (chainId !== x.network.code)
                                return Promise.reject(exports.keeperErrors.wrongNetwork);
                            return x.account;
                        }).catch(function (e) {
                            if ((e === null || e === void 0 ? void 0 : e.code) === "10" || (e === null || e === void 0 ? void 0 : e.code) === "12") {
                                return Promise.reject(exports.keeperErrors.rejectedByUser);
                            }
                            if (typeof e === 'string')
                                return Promise.reject(e);
                            return undefined;
                        }))];
                case 2:
                    acc = _b.sent();
                    return [2 /*return*/, acc ? Promise.resolve({ address: acc.address, publicKey: acc.publicKey, keeper: keeper }) :
                            keeper === null || keeper === void 0 ? void 0 : keeper.auth({ data: 'fdc4f2afe48545df89fe7078b579691b' }).then(function (authResult) { return ({ address: authResult.address, publicKey: authResult.publicKey, keeper: keeper }); })];
            }
        });
    });
};
exports.loginWithKeeper = loginWithKeeper;
//# sourceMappingURL=keeper.js.map